import Clarity from '@microsoft/clarity'
import {
  ANALYTICS_FIELD,
  COOKIE_CONSENT_CHANGED_EVENT,
  getSavedPreferences
} from './consentPreferences'

const CLARITY_PROJECT_ID = 'yfipf1cmyq'

let isLoaded = false
let hasConsent = false
let identity = null

const applyIdentity = () => {
  if (!isLoaded || !hasConsent || !identity) return
  Clarity.identify(identity.userId, undefined, undefined, identity.userName)
}

const applyConsent = (granted) => {
  hasConsent = granted
  if (granted && !isLoaded) {
    Clarity.init(CLARITY_PROJECT_ID)
    isLoaded = true
  }
  if (!isLoaded) return

  Clarity.consentV2({
    ad_Storage: 'denied',
    analytics_Storage: granted ? 'granted' : 'denied'
  })
  applyIdentity()
}

export const initClarity = () => {
  applyConsent(getSavedPreferences()?.[ANALYTICS_FIELD] === true)
  window.addEventListener(COOKIE_CONSENT_CHANGED_EVENT, (event) => {
    applyConsent(event.detail?.[ANALYTICS_FIELD] === true)
  })
}

export const identifyClarityUser = (userId, userName) => {
  if (!userId) return
  identity = { userId: String(userId), userName: userName || undefined }
  applyIdentity()
}
